import {
  Component,
  OnInit,
  ViewChild,
  Input,
  Output,
  EventEmitter
} from '@angular/core';
import { EnterpriseService } from './enterprise.service';
import { Enterprise } from './Enterprise';
import { MultiSelectComponent } from '@progress/kendo-angular-dropdowns';

@Component({
  selector: 'enterprise-multiselect',
  templateUrl: './enterprise-multiselect.component.html',
  styleUrls: ['./enterprise-multiselect.component.scss']
})
export class EnterpriseMultiselectComponent implements OnInit {
  @Input()
  selectedEnterprises: Enterprise[] = [];
  @Input()
  index: number;
  @Input()
  disabled: boolean;
  @Input()
  placeholder: string = 'Name or Account';
  @Output()
  selectedEnterpriseChange: EventEmitter<Enterprise[]> = new EventEmitter();

  @ViewChild('multiSelect', { static: true })
  public multiSelectComponent: MultiSelectComponent;
  public matches: Enterprise[] = [];
  constructor(public enterpriseService: EnterpriseService) {}

  ngOnInit() {
    if (this.selectedEnterprises) {
      this.selectedEnterprises.forEach((x) => {
        this.matches.push(x);
      });
    }
  }

  public handleFilter(filter: string) {
    if (filter.length < 3) {
      this.multiSelectComponent.toggle(false);
      return;
    }

    this.enterpriseService.search(filter).subscribe((x) => {
      this.matches = x;
    });
  }

  public valueChange(value: Enterprise[]): void {
    this.selectedEnterpriseChange.emit(value);
  }
}
